import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
import util from "@/mixins/util";
Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            display: 0, //진열상태
            category: '', //상품 카테고리
            pattern: '', //패턴
            season: '', //시즌
            color: '', //컬러
            tone: '', //톤
            gender: '', //성별
            bottomType: '', //하의
            name: '', //상품명
            link: '', //링크
            sku: '자동발급', //상품코드
            manageCode: '', //관리코드
            price: '', //상품가격
            nSearchWord: '' ,//N검색어
            nReview: '', //N리뷰수
            nRank: '', //N랭킹순위
            nDibs: '', //N찜하기수
            nCategory: '', //N 카테고리 넘버
            itemImage: [],
            detailImage: [],
            itemOptionImage: [],
            memo: '',
            locationIsUse: 0, //위치정보 기본값 사용한함
            locationName: '', // 상품의 위치
            locationFile: [], // 위치 이미지

            stockUse : 0, //재고사용
            stock : 0, //재고
            optionUse : 0, //옵션사용

            discountUse : 0, //할인여부
            discount : '', //할인

            selling : 0, //판매상태
            fitting : 0, //스마트 피팅

            //옵션 모달
            optionSeq : '',
            optionName : '',
            optionSelling : '',
            optionStockUse : '',
            optionStock : '',
            optionList : [],
            //스마트피팅 이미지
            smartFittingImage: [],

            brandData: {},//브랜드 데이터
            mainItem: '', // 대표상품
            brandKey: 0,
            brandName: '', //브랜드 이름
        }
    },
    validators: {
        optionSeq: function (value) {
            return Validator.value(value)
                .required('순서를 입력해주세요.');
        },
        optionName: function (value) {
            return Validator.value(value)
                .required('옵션명을 입력해주세요.');
        },
        optionSelling: function (value) {
            return Validator.value(value)
                .required('판매상태를 선택해주세요.');
        },
        optionStockUse: function (value) {
            return Validator.value(value)
                .required('재고관리를 선택해주세요.');
        },
        optionStock: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.optionStockUse === 1 && value === '') {
                        return '수량을 입력해주세요.';
                    }
                })
        },
        optionList: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.optionUse === 1 && util.isEmpty(value)) {
                        return '옵션을 입력해주세요.';
                    }
                })
        },
        selling: function (value) {
            return Validator.value(value)
        },
        fitting: function (value) {
            return Validator.value(value)
        },
        discount: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.discountUse === 1){
                        if(util.isEmpty(value)) {
                            return '할인 금액을 입력해주세요.';
                        }else if(Number(this.price) <= Number(value)){
                            return '할인가격은 상품가격보다 작게 설정해주세요.';
                        }
                    }
                })
        },
        discountUse: function (value) {
            return Validator.value(value)
        },
        optionUse: function (value) {
            return Validator.value(value)
        },
        stockUse: function (value) {
            return Validator.value(value)
        },
        stock: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.stockUse === 1 && util.isEmpty(value)) {
                        return '재고 수량을 입력해주세요.';
                    }
                })
        },
        display: function (value) {
            return Validator.value(value)
        },
        category: function (value) {
            return Validator.value(value)
                .required('상품 카테고리를 선택해주세요.');
        },
        pattern: function (value) {
            return Validator.value(value)
                .required('상품 패턴을 선택해주세요.');
        },
        season: function (value) {
            return Validator.value(value)
                .required('상품 시즌을 선택해주세요.');
        },
        color: function (value) {
            return Validator.value(value)
                .required('상품 컬러를 선택해주세요.');
        },
        tone: function (value) {
            return Validator.value(value)
                .required('상품 톤을 선택해주세요.');
        },
        gender: function (value) {
            return Validator.value(value)
                .required('성별을 선택해주세요.');
        },
        bottomType: function (value) {
            return Validator.value(value)
                .required('하의를 선택해주세요.');
        },
        name: function (value) {
            return Validator.value(value)
                .required('상품명을 입력해주세요.');
        },
        link: function (value) {
            return Validator.value(value)
        },
        manageCode: function (value) {
            return Validator.value(value)
                .required('상품 관리코드을 입력해주세요.');
        },
        price: function (value) {
            return Validator.value(value)
                .required('상품 가격을 입력해주세요.')
                .custom(() => {
                    if(isNaN(value) && value != '') {
                        value = value.replace(/[^0-9]/g,'')
                    }
                    let price = this.price;
                    if(isNaN(price) && price != '') {
                        price = price.replace(/[^0-9]/g,'')
                    }
                    if(value <= 0) {
                        return '상품가격은 0보다 큰 값으로 입력해주세요.'
                    }
                })
        },
        nSearchWord: function (value) {
            return Validator.value(value)
                .required('상품 N 검색어를 입력해주세요.');
        },
        nRank: function (value) {
            return Validator.value(value)
                .required('상품 N 랭킹순위를 입력해주세요.')
                .integer('상품 N 랭킹순위를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 랭킹순위를 입력하세요.')
        },
        nReview : function (value) {
            return Validator.value(value)
                .required('상품 N 리뷰수를 입력해주세요.')
                .integer('상품 N 리뷰수를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 리뷰수를 입력하세요.')
        },
        nDibs: function (value) {
            return Validator.value(value)
                .required('상품 N 찜하기수를 입력해주세요.')
                .integer('상품 N 찜하기수를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 찜하기수를 입력하세요.')
        },
        nCategory: function (value) {
            return Validator.value(value)
                .required('상품 N 카테고리 넘버를 입력해주세요.')
                .integer('상품 N 카테고리 넘버를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 카테고리 넘버를 입력하세요.')
        },
        itemImage: function (value) {
            return Validator.value(value)
                .required('상품 대표이미지를 선택해주세요.')
        },
        itemOptionImage: function (value) {
            return Validator.value(value)
        },
        detailImage: function (value) {
            return Validator.value(value)
                .required('상세 이미지를 선택해주세요.')
        },
        memo: function (value) {
            return Validator.value(value)
        },
        locationIsUse: function (value) {
            return Validator.value(value)
        },
        locationName: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.locationIsUse === 1 && util.isEmpty(value)) {
                        return '상품 위치를 선택해주세요.';
                    }
                })
        },
        locationFile: function (value) {
            return Validator.value(value)
                .required('상품 위치이미지를 선택해주세요.')
            // .custom(
            //   () => {
            //       if(this.ibl_is_use === 1 && util.isEmpty(value)) {
            //           return '상품 위치이미지를 선택해주세요.';
            //       }
            //   })
        },
        smartFittingImage: function (value) {
            return Validator.value(value)
                .custom(
                  () => {
                      if(this.fitting === 1 && util.isEmpty(value)) {
                          return '스마트 피팅 이미지를 선택해주세요.';
                      }
                  })
        },
        brandData: function (value) {
            return Validator.value(value)
        },
        mainItem:  function (value) {
            return Validator.value(value)
        },
        brandKey: function (value) {
            return Validator.value(value)
        },
        brandName: function (value) {
            return Validator.value(value)
                .required('브랜드를 선택/입력해주세요.')
        },
    },
}
